import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Icon, Menu } from 'ant-design-vue';
let Nav = class Nav extends Vue {
    constructor() {
        super(...arguments);
        this.current = [this.$route.name];
    }
};
Nav = __decorate([
    Component({
        name: 'Nav',
        components: {
            'a-menu': Menu,
            'a-menu-item': Menu.Item,
            'a-icon': Icon
        }
    })
], Nav);
export default Nav;
